<template>
  <div class="SubPage__container">
    <PageHeader />
    <div class="SubPage__contentGrid SubPage__firstGrid">
      <Breadcrumbs :crumbs="crumbs" />
      <div class="SubPage__header columns is-mobile">
        <div class="column">
          <h1 class="SubPage__title">
            <slot name="title" />
          </h1>
        </div>
        <SocialSharing :socialSharingLinks="socialSharingLinks" />
      </div>
    </div>
    <div class="SubPage__contentGrid">
      <FAQList :config="FAQListConfig" />
    </div>
    <Footer />
  </div>
</template>

<script>
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs.vue";
import Footer from "../Footer/Footer.vue";
import PageHeader from "../PageHeader/PageHeader.vue";
import FAQList from "../FAQList/FAQList.vue";
import SocialSharing from "../SocialSharing/SocialSharing.vue";

export default {
  name: "FAQPage",
  components: {
    Breadcrumbs,
    Footer,
    PageHeader,
    FAQList,
    SocialSharing
  },
  props: {
    crumbs: {
      default: undefined
    },
    socialSharingLinks: {
      default: undefined
    },
    FAQListConfig: {
      default: undefined
    }
  }
};
</script>
